import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { CollectionName } from '@/shared/lib/sj-orm';
import { Icon } from '@/shared/uikit/Icon';
import { Text } from '@/shared/uikit/Text';

import { useModalsStore } from '../../modals.store';

import { TableDataRow } from './types';

export const useColumnDefs = () => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'beneficiaryRelations' });
  const modals = useModalsStore();

  const entityNameMap: Partial<Record<CollectionName, string>> = {
    [CollectionName.ASSETS]: t('table.asset'),
    [CollectionName.PRIVATE_DOCUMENTS]: t('table.privateDocument'),
    [CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS]: t('table.personalIdentifier'),
    [CollectionName.INTERWILLS]: t('table.interwill'),
    [CollectionName.SCENARIO_META_INFO]: t('table.scenario'),
  };

  return [
    {
      key: 'title',
      title: t('table.title'),
      render: (item: TableDataRow) => (
        <StyledLink href={item.link} onClick={() => modals.closeModal()}>
          <Icon name="arrow-square-out" size="s20" />
          <span>{item.title}</span>
        </StyledLink>
      ),
    },
    {
      key: 'itemType',
      title: t('table.itemType'),
      render: (item: TableDataRow) => <Text>{entityNameMap[item.itemType]}</Text>,
    },
  ];
};

const StyledLink = styled(Link)`
  &&& {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: ${COLORS.systemSky200};
  }
`;
